module.exports = __webpack_public_path__ + "assets/fifty.0410da3e0c09c862522939140735bff94e251a1e594a740d535e4ec7d787cc17.png";